import { Chip, Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Grid, Typography } from '@mui/material';
import { memo } from 'react';
import { useEntitlementActive } from '../../../../hooks/use-entitlement-active';
import { useRenderValueEntitlement } from '../../../../hooks/use-render-value-entitlement';
import * as Styled from './styles';
import * as SX from './sx';
import type { EntitlementRowProps as Props } from './types';

export const EntitlementRow = memo(({ className, item, itemIndex }: Props) => {
  const { isActiveInFree, isActiveInPaid } = useEntitlementActive();
  const { renderFreeValue, renderPaidValue } = useRenderValueEntitlement();

  return (
    <Styled.Wrapper
      className={classnames('EntitlementRow', className)}
      sx={SX.root}
      direction="column"
      gap={1}
      mt={2}
    >
      <Grid container key={itemIndex} sx={SX.detailRow(itemIndex)}>
        <Grid item xs={6}>
          <Typography variant="body3" fontWeight={400} color="common.black">
            {item.name}
          </Typography>
        </Grid>
        <Grid item xs={3.05} sx={SX.grid}>
          {item.metadata.value ? (
            <Chip
              size="small"
              label={renderFreeValue(item.name)}
              variant="outlined"
              shape="rounded"
            />
          ) : (
            <Icon
              name="check-circle-outline"
              size={20}
              color={isActiveInFree(item.products) ? 'primary.400' : 'grey.400'}
            />
          )}
        </Grid>
        <Grid item xs={2} sx={SX.grid}>
          {item.metadata.value ? (
            <Chip
              size="small"
              label={renderPaidValue(item.name)}
              variant="outlined"
              shape="rounded"
            />
          ) : (
            <Icon
              name="check-circle-outline"
              size={20}
              color={isActiveInPaid(item.products) ? 'primary.400' : 'grey.400'}
            />
          )}
        </Grid>
      </Grid>
    </Styled.Wrapper>
  );
});

EntitlementRow.displayName = 'EntitlementRow';
